/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import Container from "../GlobalComponents/Container";
import Form from "./Form";
import Footer from './Footer'
const Contact = () => (
  <section css={styles} className="contact" id="contact">
    <Container>
      <Form />
    </Container>
     <Footer/>
  </section>
);

const styles = css`
  width: 100%;
  .container {
    max-width: 100%;
    display: flex;
  }
  footer {
    text-align: center;
    padding: 0;
    p{
      font-size: 14px;
      color: white;
      letter-spacing:"1px";
      a{
        text-decoration: none;
        color: #ed563b;
        font-weight: 500;
        &:hover {
          color: #ed563b;
        }
      }
    }
  }
 
  @media(max-width: 1200px) {
    .container{
      flex-direction: column-reverse;
      align-items: center;
    }
  }
`;

export default Contact;
